import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { SortTaskSubTasksArgs, Task } from '@ztechapps/common.contract'
import { taskDocumentFragment } from './graphql'

export const sortTaskSubTasksQuery = gql`
  mutation sortTaskSubTasks($input: SortTaskSubTasksArgs!) {
    sortTaskSubTasks(input: $input) {
      ...taskDocumentFragment
    }
  }
  ${taskDocumentFragment}
`

export const useSortTaskSubTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Task, SortTaskSubTasksArgs> => {
  query = query ?? sortTaskSubTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
